import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { ClientStatus } from './constants';
import ClientGridActionButtons from './action-buttons';
import messages from './messages';
import style from './style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const ClientRow = ({ client, reloadGrid = noop, existingClients = emptyArray }) => {
  const intl = useIntl();
  const { clientName, status = ClientStatus.ACTIVE, clientEmail } = client;
  return (
    <>
      <div className={classnames(style.cell, style.left)}>
        <span>{clientName}</span>
      </div>
      <div className={classnames(style.cell, style['align-left'])}>{status === ClientStatus.PENDING && clientEmail}</div>
      <div className={style.cell}>{intl.formatMessage(messages[status])}</div>
      <div className={style.cell} />
      <div className={classnames(style.cell, style.right)}>
        <ClientGridActionButtons client={client} existingClients={existingClients} reloadGrid={reloadGrid} />
      </div>
    </>
  );
};

ClientRow.propTypes = {
  client: PropTypes.shape({
    clientName: PropTypes.string,
    clientEmail: PropTypes.string,
    status: PropTypes.oneOf([ClientStatus.ACTIVE, ClientStatus.INACTIVE, ClientStatus.PENDING]),
  }).isRequired,
  existingClients: PropTypes.arrayOf(
    PropTypes.shape({
      clientName: PropTypes.string,
      clientEmail: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  reloadGrid: PropTypes.func,
};

export default ClientRow;
